/**
 * Defines the constants used by the Upload module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
export const VUEX_UPLOAD_REQUEST              = 'VUEX_UPLOAD_REQUEST'
export const VUEX_UPLOAD_REQUEST_SUCCESS      = 'VUEX_UPLOAD_REQUEST_SUCCESS'
export const VUEX_UPLOAD_REQUEST_FAILURE      = 'VUEX_UPLOAD_REQUEST_FAILURE'
export const VUEX_UPLOAD_SET_FILE_TO_UPLOAD   = 'VUEX_UPLOAD_SET_FILE_TO_UPLOAD'

export const VUEX_UPLOAD_S3_PART_SIZE         = 5 * 1024 * 1024;
export const VUEX_UPLOAD_S3_QUEUE_SIZE        = 4;
export const VUEX_UPLOAD_S3_ACL               = 'public-read';


export const VUEX_UPLOAD_ABORT_UPLOAD         = 'VUEX_UPLOAD_ABORT_UPLOAD'
